export const getHtmlFor = (
    name: string | symbol | number
): string | undefined =>
    typeof name === 'number' || typeof name === 'symbol'
        ? name.toString()
        : name;
